module.exports = __webpack_public_path__ + "static/media/logo.f0ce32c2.png";